import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = { class: "country-avatar__initials" }

import { computed } from 'vue'
import {
  getCountryAvatarColor,
  getCountryAvatarSizePx,
  getCountryInitials,
  type CountryAvatarSize,
} from '@/utils/countryAvatar'


export default /*@__PURE__*/_defineComponent({
  __name: 'CountryAvatar',
  props: {
    country: { default: '' },
    fallbackLabel: { default: '' },
    size: { default: 'md' }
  },
  setup(__props: any) {

const props = __props

const displayLabel = computed(() => props.country || props.fallbackLabel || '')
const initials = computed(() => getCountryInitials(props.country, props.fallbackLabel || undefined))
const avatarStyle = computed(() => ({
  width: `${getCountryAvatarSizePx(props.size)}px`,
  height: `${getCountryAvatarSizePx(props.size)}px`,
  backgroundColor: getCountryAvatarColor(props.country || props.fallbackLabel),
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["country-avatar", [`country-avatar--${_ctx.size}`]]),
    style: _normalizeStyle(avatarStyle.value),
    title: displayLabel.value,
    role: "img",
    "aria-label": displayLabel.value
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(initials.value), 1)
  ], 14, _hoisted_1))
}
}

})